import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import ProjetosList from "./pages/ProjetosList";
import CriarProjeto from "./pages/CriarProjeto";
import ProjetoDetalhes from "./pages/ProjetoDetalhes";
import CriarLocal from "./pages/CriarLocal";
import AuditoriaForm from "./pages/AuditoriaForm";
import InventarioForm from "./pages/InventarioForm";
import InventarioLista from "./pages/InventarioLista";

import Login from "./pages/Login";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

import UsersList from "./pages/UsersList";
import ChangePassword from "./pages/ChangePassword";
import Operadores from "./pages/Operadores";
import Formatos from "./pages/Formatos";
import Tipologias from "./pages/Tipologias";
import InventarioDetalhes from "./pages/InventarioDetalhes";
import LocalizacaoGestao from "./pages/LocalizacaoGestao";
import Tipos from "./pages/Tipos";
import TiposLocalizacao from "./pages/TiposLocalizacao";
import InventarioMapa from "./pages/InventarioMapa";
import RelatorioCampanhas from "./pages/RelatorioCampanhas";
import CampoFace from "./pages/CampoFace";
import CampoInventario from "./pages/CampoInventario";
import RelatorioProvas from "./pages/RelatorioProvas";

function App() {

  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
    setLoading(false);
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <>
      {token && <Navbar />}

      <Routes>

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* REDIRECT INICIAL */}
        <Route
          path="/"
          element={
            token ? (
              <Navigate to="/projetos" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* PROJETOS */}
        <Route path="/projetos" element={
          <ProtectedRoute>
            <ProjetosList />
          </ProtectedRoute>
        } />

        <Route path="/projetos/novo" element={
          <ProtectedRoute>
            <CriarProjeto />
          </ProtectedRoute>
        } />

        <Route path="/projetos/:id" element={
          <ProtectedRoute>
            <ProjetoDetalhes />
          </ProtectedRoute>
        } />

        <Route path="/projetos/:id/locais/novo" element={
          <ProtectedRoute>
            <CriarLocal />
          </ProtectedRoute>
        } />

        {/* AUDITORIA */}
        <Route path="/auditar/:localId" element={
          <ProtectedRoute>
            <AuditoriaForm />
          </ProtectedRoute>
        } />

        {/* INVENTÁRIO */}
        <Route path="/inventario/novo" element={
          <ProtectedRoute>
            <InventarioForm />
          </ProtectedRoute>
        } />

        <Route path="/inventario/lista" element={
          <ProtectedRoute>
            <InventarioLista />
          </ProtectedRoute>
        } />

        <Route path="/inventario/:id" element={
          <ProtectedRoute>
            <InventarioDetalhes />
          </ProtectedRoute>
        } />
        {/* INVENTARIO MAPA*/}
        <Route path="/inventario/mapa" element={
          <ProtectedRoute>
            <InventarioMapa />
          </ProtectedRoute>
        } />
        {/* USERS (ADMIN) */}
        <Route path="/users" element={
          <ProtectedAdminRoute>
            <UsersList />
          </ProtectedAdminRoute>
        } />

        {/* PASSWORD */}
        <Route path="/change-password" element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        } />

        {/* OPERADORES (ADMIN) */}
        <Route path="/operadores" element={
          <ProtectedAdminRoute>
            <Operadores />
          </ProtectedAdminRoute>
        } />

        {/* FORMATOS (ADMIN) */}
        <Route path="/formatos" element={
          <ProtectedAdminRoute>
            <Formatos />
          </ProtectedAdminRoute>
        } />

        {/* TIPOLOGIAS (ADMIN) */}
        <Route path="/tipologias" element={
          <ProtectedAdminRoute>
            <Tipologias />
          </ProtectedAdminRoute>
        } />

        {/* LOCALIZAÇÕES (ADMIN) */}
        <Route path="/localizacoes" element={
          <ProtectedAdminRoute>
            <LocalizacaoGestao />
          </ProtectedAdminRoute>
        } />
        {/* tipos  */}
        <Route path="/tipos" element={
          <ProtectedRoute>
            <Tipos />
          </ProtectedRoute>
        } />
        {/* tipos de localização */}
        <Route
          path="/tipos-localizacao"
          element={
            <ProtectedAdminRoute>
              <TiposLocalizacao />
            </ProtectedAdminRoute>
          }
        />
        {/* relatorios campanhas */}
        <Route
          path="/relatorios/campanhas"
          element={<RelatorioCampanhas />}
        />
        {/* relatorios provas*/}
        <Route
          path="/relatorios/provas"
          element={<RelatorioProvas />}
        />

        {/* MODO CAMPO — INSERÇÃO RÁPIDA DE CAMPANHAS */}
        <Route
          path="/campo/face/:faceId"
          element={
            <ProtectedRoute>
              <CampoFace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/campo/inventario/:inventarioId"
          element={
            <ProtectedRoute>
              <CampoInventario />
            </ProtectedRoute>
          }
        />


        {/* CATCH-ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </>
  );
}

export default App;
